"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initials = exports.isEmptyArray = void 0;
function isEmptyArray(arr) {
    return !arr || arr.length === 0;
}
exports.isEmptyArray = isEmptyArray;
function initials(text) {
    const split = text.split(/\s/);
    if (split.length == 0) {
        return text.toUpperCase();
    }
    else if (split.length == 1) {
        return split[0].charAt(0).toUpperCase();
    }
    else {
        return (split[0].charAt(0) + split[1].charAt(0)).toUpperCase();
    }
}
exports.initials = initials;
